import React, { useContext } from "react";
import { Home, Layers, Briefcase, Users, LogOut } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { MyContext } from "../../hooks/MyContextProvider";

const MobileHeader = () => {
  const location = useLocation();
  const {
    tabContent,
    setTabContent,
    theme,
    companyData,
    updateCompanyData,
    updateToken,
  } = useContext(MyContext);
  const handleLogout = () => {
    // Add your logout logic here
    console.log("Logout clicked");
  };

  return (
    <div
      className="tab"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        backgroundColor: theme === "dark" ? "#111827" : "#ffffff",
        boxShadow: "0 -2px 15px rgba(0,0,0,0.08)",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "12px 0",
        color: theme === "dark" ? "#ffffff" : "#000000",
        zIndex: 1000,
      }}
    >
      <Link
        to="/dashboard"
        className="custom-button"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onClick={() => setTabContent("home")}
      >
        <Home
          size={24}
          style={{ width: "max-content" }}
          color={
            tabContent === "home"
              ? "rgb(205 108 231)"
              : theme === "dark"
              ? "#ffffff"
              : "#000000"
          }
        />
        <span
          style={{
            fontSize: "12px",
            color:
              tabContent === "home"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
            fontWeight: 500,
          }}
        >
          Home
        </span>
      </Link>
      <Link
        to="/dashboard"
        className="custom-button"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onClick={() => setTabContent("profile")}
      >
        <i
          className="fa-regular fa-user"
          style={{
            fontSize: "24px",
            width: "max-content",
            color:
              tabContent === "profile"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
          }}
        ></i>
        <span
          style={{
            fontSize: "12px",
            color:
              tabContent === "profile"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
            fontWeight: 500,
          }}
        >
          About
        </span>
      </Link>
      <Link
        to="/dashboard"
        className="custom-button"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onClick={() => setTabContent("service")}
      >
        <Layers
          size={24}
          style={{ width: "max-content" }}
          color={
            tabContent === "service"
              ? "rgb(205 108 231)"
              : theme === "dark"
              ? "#ffffff"
              : "#000000"
          }
        />
        <span
          style={{
            fontSize: "12px",
            color:
              tabContent === "service"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
            fontWeight: 500,
          }}
        >
          Services
        </span>
      </Link>
      <Link
        to="/dashboard"
        className="custom-button"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onClick={() => setTabContent("portfolio")}
      >
        <Briefcase
          size={24}
          style={{ width: "max-content" }}
          color={
            tabContent === "portfolio"
              ? "rgb(205 108 231)"
              : theme === "dark"
              ? "#ffffff"
              : "#000000"
          }
        />
        <span
          style={{
            fontSize: "12px",
            color:
              tabContent === "portfolio"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
            fontWeight: 500,
          }}
        >
          Training
        </span>
      </Link>
      <Link
        to="/member"
        className="custom-button"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onClick={() => setTabContent("")}
      >
        <Users
          size={24}
          style={{ width: "max-content" }}
          color={
            location.pathname === "/member"
              ? "rgb(205 108 231)"
              : theme === "dark"
              ? "#ffffff"
              : "#000000"
          }
        />
        <span
          style={{
            fontSize: "12px",
            color:
              location.pathname === "/member"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
            fontWeight: 500,
          }}
        >
          Members
        </span>
      </Link>
      <Link
        to="/message"
        className="custom-button"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4px",
          textDecoration: "none",
        }}
        onClick={() => setTabContent("")}
      >
        <i
          className="fa-regular fa-envelope"
          style={{
            fontSize: "24px",
            width: "max-content",
            color:
              location.pathname === "/message"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
          }}
        ></i>
        <span
          style={{
            fontSize: "12px",
            color:
              location.pathname === "/message"
                ? "rgb(205 108 231)"
                : theme === "dark"
                ? "#ffffff"
                : "#000000",
            fontWeight: 500,
          }}
        >
          Message
        </span>
      </Link>
    </div>
  );
};

export default MobileHeader;
